import script from "./Honors.vue?vue&type=script&setup=true&lang=js"
export * from "./Honors.vue?vue&type=script&setup=true&lang=js"

import "./Honors.vue?vue&type=style&index=0&id=76e28728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e28728"]])

export default __exports__